import React, { FC, useEffect, useState} from 'react';
import { Edit, EditProps, FormTab, TabbedForm, useEditController } from 'react-admin';
import { Prize } from '../../types/prize';
import DiscountAndTickets from '../common/discount/DiscountTickets';
import PrizeGeneralForm from './PrizeGeneralForm';
import PrizeToolbar from './PrizeToolbar';
import "./index.css"
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import { useSelector } from "react-redux";
import { CreditProps } from '../common/generalPickersBlocks/credits/CreditsPickerComponent';
import { Overview } from '../dreamHome/shared/overview/OverviewBlock';
import { OverviewProvider } from '../dreamHome/shared/overview/OverviewContext';

const PrizeEdit: FC<EditProps> = (props) => {
  const controllerProps = useEditController<Prize>(props)
  const stateApp = useSelector((state) => state);
  const isCopy = stateApp.property.isNew
  const [state, setState] = useState({
    isCash: false,
    isPercent: false,
  });
  const [overview, setOverview] = useState<Array<Overview>>([])
  const [overviewError, setOverviewError] = useState(false)
  const [errors, setError] = useState({
    imagesError: false,
    discountFillError: false
  })

  const [isDiscountValidate, setIsDiscountValidate] = useState(false)
  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: "2031-01-18T19:55:00.000+00:00",
  });
  const [creditDateType, setCreditDateType] = useState<string>("allDate");

  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };

  const [stateCredits, setCredits] = useState<Array<CreditProps>>([
    {
      id: "1",
      count: 20,
      percent: 30,
    },
  ]);

  useEffect(() => {
    if (controllerProps.record) {
      if (controllerProps.record.creditsRates) setCredits(controllerProps.record.creditsRates);
      setDoesCreditsActive(controllerProps.record.isCreditsActive);
      setDatesValue({
        startDateValue: controllerProps.record.creditsStartDate && new Date(controllerProps.record.creditsStartDate) || new Date(),
        endDateValue: controllerProps.record.creditsEndDate && new Date(controllerProps.record.creditsEndDate) || new Date("2031-01-18T19:55:00.000+00:00"),
      });
      if (controllerProps.record.overview) {
        setOverview(controllerProps.record.overview);
      }
      if (controllerProps.record.isCreditsPermanent) {
        setCreditDateType("allDate");
      } else {
        setCreditDateType("date");
      }
    }
  }, [controllerProps.record]);

  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };

  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };
  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  const handleDiscountFillError = (error: boolean) => {
    setError({ ...errors, discountFillError: error })
  }

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };

  const handleImagesError = (error: boolean) => {
    setError({ ...errors, imagesError: error })
  }
  return (
    <>
      <DocumentTitle core="Prize" secondary="Lifestyle Prizes" purpose={isCopy ? "Copy" : "Edit"} appointment="Lifestyle Prize" />
      <Edit {...props}>
        <TabbedForm toolbar={PrizeToolbar(props, false, overview,setOverviewError, handleImagesError, handleDiscountFillError, setIsDiscountValidate, {
          creditsArr: stateCredits,
          dateType: creditDateType,
          creditsStartDate: datesValue.startDateValue,
          creditsEndDate: datesValue.endDateValue,
          creditsStatus: isActiveCredits,
        })} className="general-tab">
          <FormTab label="General">
            <OverviewProvider prizeType="prize">
              <PrizeGeneralForm
                imagesError={errors.imagesError}
                record={controllerProps.record}
                isShow={false}
                isPrize={true}
                properties={overview}
                setProperties={setOverview}
                overviewError={overviewError}
              />
            </OverviewProvider>
          </FormTab>
          <FormTab label="Discount & tickets">
            <DiscountAndTickets
              entity={controllerProps.record}
              isShow={false}
              isCash={state.isCash}
              isPercent={state.isPercent}
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountSource="discountCategory"
              ticketPrice={controllerProps.record?.ticketPrice ? controllerProps.record?.ticketPrice : 0}
              discountFillError={errors.discountFillError}
              isOdds={false}
              isValidate={isDiscountValidate}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              competition="prize"
            />
          </FormTab>
        </TabbedForm>
      </Edit>
    </>
  )
}

export default PrizeEdit